import { render, staticRenderFns } from "./addBatchUpdata.vue?vue&type=template&id=3c44df86&scoped=true"
import script from "./addBatchUpdata.vue?vue&type=script&lang=js"
export * from "./addBatchUpdata.vue?vue&type=script&lang=js"
import style0 from "./addBatchUpdata.vue?vue&type=style&index=0&id=3c44df86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c44df86",
  null
  
)

export default component.exports